import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material"
import { CustomTable } from "../../../../../../../../components"
import Loader from "../../../../../../../../components/loader"
import { PermissionAsssignmentProps } from "./types"
import { FiltersDrawer } from "../../../../../../../../components/filtersDrawer"
import { useContextState } from "../../../../../../../../hooks/theme"
import { LoadingButton } from "@mui/lab"
import { icons } from "../../../../../../../../utils/icons"




export const PermissionAsssignment = (props: PermissionAsssignmentProps) => {
    const { t } = useTranslation()
    const styles = useStyles()
    const { colors } = useContextState()

    return (
        <Box>
            <Box sx={styles.titleFolio}>
                <Typography variant='subtitle_grey' fontWeight={'bold'}>{t('department.form.tabs.titleFolio')}</Typography>

                <Box sx={styles.headerActions} className="user-list-item">
                    <Box sx={styles.finishBtn}>
                        {
                            !!props.deleteSelected?.length && (
                                <Button
                                    /* disabled={generalDisabled(createEdit, data)} */
                                    onClick={props.deletedUsersSelecteds}
                                    variant="container_error"
                                >
                                    {t('general.deleteSelected')}
                                </Button>
                            )
                        }

                        <LoadingButton
                            /* disabled={generalDisabled(createEdit, data)} */
                            onClick={() => {
                                    props.handleSubmit()
                            }}
                            loading={props.submitLoading}
                            variant="contained"
                        >
                            {t('general.save')}
                        </LoadingButton>
                    </Box>

                    <Box sx={styles.all}>
                        <Typography
                            sx={styles.select}
                            onClick={() => {
                                props.unSelectOrSelectAllUsersFolios({ value: true })
                            }}
                        >
                            {t('schedule.buttons.addTruechecket')}
                        </Typography>

                        <Typography sx={styles.line}>|</Typography>

                        <Typography
                            sx={styles.select}
                            onClick={() => {
                                props.unSelectOrSelectAllUsersFolios({ value: false })
                            }}
                        >
                            {t('schedule.buttons.addFalsechecket')}
                        </Typography>
                    </Box>
                </Box>
            </Box>

            {/* TABLE */}
            {!props.loadingTable ?
                <CustomTable
                    tableChecks
                    defaultChecks={props.deleteSelected}
                    onClick={(payload) => {
                        props.setDeletedSelected(payload?.checks ?? [])
                    }}
                    dontRefresh
                    name={t('general.tags.departments')}
                    column={props.columnFolio}
                    row={props.rowFiltered}
                    color={colors}
                    selected={-1} />
                 : <Loader />} 


            <FiltersDrawer cleanFilter={props.cleanFilter} count={props.counter} right={-74} top={-97}>
                <Box sx={styles.section}>
                    {props.floatItems}
                </Box>
            </FiltersDrawer>
        </Box>
    )
}